// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { MapSectorLayer_abstract } from './../abstract/SagaBase/MapSectorLayer_abstract';
export class MapSectorLayer extends MapSectorLayer_abstract {}
